import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HomeRoutingModule } from './home-routing.module';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MaterialModule } from '../route-file/material.module';
import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
// Home Component Declare here
import {
  HomeComponent,DealComponent,DetailComponent,PrivacyPolicyComponent,ProfileComponent,SearchDetailComponent,TermsConditionComponent
  } from '../home';
import { SuccessComponent } from './success/success.component';
import { UnsuccessComponent } from './unsuccess/unsuccess.component';
import { OffersComponent } from './offers/offers.component';
import { OfferViewComponent } from './offer-view/offer-view.component';
import { AboutusComponent } from './aboutus/aboutus.component';
import { ContactusComponent } from './contactus/contactus.component';
import { HomeSectorComponent } from './home-sector/home-sector.component';
import { TourDetailComponent } from './tour-detail/tour-detail.component';



@NgModule({
  declarations: [
    HomeComponent, ProfileComponent, DealComponent, DetailComponent, SearchDetailComponent, TermsConditionComponent, PrivacyPolicyComponent, SuccessComponent,UnsuccessComponent, OffersComponent ,OfferViewComponent, AboutusComponent, ContactusComponent, HomeSectorComponent, TourDetailComponent],
  // declarations: [
  //   HomeComponent, ProfileComponent, DealComponent, DetailComponent, SearchDetailComponent, TermsConditionComponent, PrivacyPolicyComponent, SuccessComponent,UnsuccessComponent, OffersComponent, OfferViewComponent, AboutusComponent, ContactusComponent, HomeSectorComponent],
  imports: [
    CommonModule,
    HomeRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    MatCheckboxModule,
    MatSelectModule,
    MaterialModule,
    MatDatepickerModule
  ],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})
export class HomeModule {

  checked = false;

 }
